import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify'; // Asegúrate de que está correctamente importado
import 'react-toastify/dist/ReactToastify.css';

const MaterialCostCalculator = () => {
  const [materials, setMaterials] = useState([{ id: Date.now(), name: '', cost: '', quantity: 1 }]);
  const [totalCost, setTotalCost] = useState(0);

  useEffect(() => {
    const savedMaterials = JSON.parse(localStorage.getItem('materials')) || [{ id: Date.now(), name: '', cost: '', quantity: 1 }];
    setMaterials(savedMaterials);
  }, []);

  useEffect(() => {
    localStorage.setItem('materials', JSON.stringify(materials));
  }, [materials]);

  const handleInputChange = (index, event) => {
    const values = [...materials];
    const { name, value } = event.target;
    if (name === 'cost' && (isNaN(value) || parseFloat(value) < 0)) {
      return;
    }
    values[index][name] = value;
    setMaterials(values);
  };

  const addMaterial = () => {
    setMaterials([...materials, { id: Date.now(), name: '', cost: '', quantity: 1 }]);
    toast.success('Material añadido');
  };

  const removeMaterial = (id) => {
    const values = materials.filter(material => material.id !== id);
    setMaterials(values);
    toast.info('Material eliminado');
  };

  const incrementQuantity = (index) => {
    const values = [...materials];
    values[index].quantity = (parseFloat(values[index].quantity) || 1) + 1;
    setMaterials(values);
  };

  const decrementQuantity = (index) => {
    const values = [...materials];
    if (values[index].quantity > 1) {
      values[index].quantity -= 1;
      setMaterials(values);
    }
  };

  useEffect(() => {
    const total = materials.reduce((sum, material) => sum + (parseFloat(material.cost || 0) * parseFloat(material.quantity || 1)), 0);
    setTotalCost(total);
  }, [materials]);

  const inputClass = (value) => value === '' ? 'border-red-500' : 'border-gray-300';

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg mb-6">
      <ToastContainer />
      <h2 className="text-3xl font-bold mb-4">Calculadora de Costos de Materiales</h2>
      {materials.map((material, index) => (
        <div key={material.id} className="flex mb-2 items-center">
          <input 
            type="text" 
            placeholder="Nombre del material" 
            name="name" 
            value={material.name} 
            onChange={(e) => handleInputChange(index, e)} 
            className={`w-1/3 p-2 border rounded ${inputClass(material.name)}`} 
          />
          <input 
            type="number" 
            placeholder="Costo" 
            name="cost" 
            value={material.cost} 
            onChange={(e) => handleInputChange(index, e)} 
            className={`w-1/3 p-2 border rounded ml-2 ${inputClass(material.cost)}`} 
          />
          <div className="flex items-center ml-2">
            <button onClick={() => decrementQuantity(index)} className="px-2 py-1 bg-gray-300 rounded-l">-</button>
            <input 
              type="number" 
              name="quantity" 
              value={material.quantity} 
              onChange={(e) => handleInputChange(index, e)} 
              className="w-12 p-2 text-center border-t border-b border-gray-300" 
            />
            <button onClick={() => incrementQuantity(index)} className="px-2 py-1 bg-gray-300 rounded-r">+</button>
          </div>
          <button onClick={() => removeMaterial(material.id)} className="ml-4 text-red-500">Eliminar</button>
        </div>
      ))}
      <button onClick={addMaterial} className="px-4 py-2 bg-blue-500 text-white rounded mb-4">Añadir Material</button>
      {totalCost > 0 && <p className="mt-4 text-xl font-semibold text-green-600">Costo Total: ${totalCost.toFixed(2)}</p>}
    </div>
  );
};

export default MaterialCostCalculator;
